export const environment = {
  name: 'prod',
  production: true,
  protocol: 'https://',
  baseAddress: 'api.monek.com',
  odinBaseAddress: 'api.monek.com/odin',
  clientRoot: 'https://portal.monek.com/',
  apiRoot: 'api.monek.com/odin/',
  releaseVersion: 'v1.42.2',

  // cognito
  userPoolId: 'eu-west-2_sXBBTJKkp',
  appClientId: '2p60iqblj21910inec6qti9u5i',
  hostedLoginUrl: 'https://authorise.monek.com',
  authCallbackUrl: 'https://portal.monek.com/authentication/auth-callback',

  congitoResource: 'https://portal.monek.com/dashboard',
  cognitoAudience: 'https://api.monek.com/odin/transactions',

  //xero
  xeroProtocol: 'https://',
  xeroBaseAddress: 'api.monek.com/lofn-xero',

  //notifications
  notificationWebSocketUrl: 'wss://ws.monek.com/notifications-ws',

  // CloudWatch RUM app monitor Odin-Merchant-Portal (Odin-Telemetry-Account stack).
  rum: {
    appMonitorId: '42b9f471-ecaf-4152-927f-723e718aa9ba',
    region: 'eu-west-2',
    // The app monitor's resource-based policy allows unsigned PutRumEvents for this alias.
    alias: 'prod',
    applicationVersion: 'v1.42.2',
    sessionSampleRate: 0.05,
  },

  // Fraction of requests sent with the sampled flag (ADR §5: dev/staging 1.0, prod 0.1). Server sampling is parent-based.
  trace: {
    sampleRate: 0.1,
  },

  featureToggles: {
    'trace-propagation': true,
    'rum-telemetry': true,
    fuzzySearch: true,
    'txn-recharge': false,
    'txn-complete': true,
    'pci-widget': false,
    'dashboard-metrics': true,
    'user-mfa-management': true,
    'pebl-qr': true,
    'extended-transactions': true,
    'mid-visibility': true,
    forumpay: false,
    'all-access-profile': true,

    // TODO: Cognito Hosted UI
    'new-profile-login': false,
    'new-token-refresh': false,
    'mfa-configuration': true,
    'new-transaction-experience': false,
  },

  brandings: [
    {
      name: 'MONEK BRANDING',
      logoUrl: '/assets/images/logo.png',
      brandName: 'MONEK',
      hasTextLogo: true,
      textLogoClass: 'monek-font',
      fixedTheme: false, // can change theming?
      themeClass: '', // theme class if fixedTheme is true
      logoWidth: 'auto',
      logoHeight: '20px',
      availableThemes: [
        { value: 'light', view: 'Light Mode' },
        { value: 'dark', view: 'Dark Mode' },
      ],
    },
  ],
  selectedBrandName: 'MONEK BRANDING',
};
